import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import WebsitesView from "../views/WebsitesView.vue";
import ContactView from "../views/ContactView.vue";
import TechConsultView from "../views/TechConsultView.vue";
import MentorshipView from "../views/MentorshipView.vue";
import ArtView from "../views/ArtView.vue";
import ReviewView from "../views/ReviewView.vue";
import PersonalSampleView from "../views/PersonalSampleView.vue";
import CheckoutExampleView from "../views/CheckoutExampleView.vue";
import ExplorerView from "../views/ExplorerView.vue";
import LoginView from "../views/LoginView.vue";
import InvoiceView from "../views/InvoiceView.vue";
import SuccessView from "../views/SuccessView.vue";
import StripeSuccessView from "../views/StripeSuccessView.vue";
import SquareConnectSuccessView from "../views/SquareConnectSuccessView.vue";
import TermsView from "../views/TermsView.vue";
import { useUser } from "@/stores";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/register",
    name: "register",
    component: LoginView,
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/register",
    name: "register",
    component: LoginView,
  },
  {
    path: "/forgot",
    name: "forgot",
    component: LoginView,
  },
  {
    path: "/logout",
    name: "logout",
    component: LoginView,
  },
  {
    path: "/explorer/dashboard",
    name: "explorer",
    component: ExplorerView,
    // meta: { requiresAuth: true },
    // beforeEnter: guard,
  },
  {
    path: "/explorer/reviews",
    name: "reviews",
    component: ExplorerView,
  },
  {
    path: "/explorer/reviewers",
    name: "reviewers",
    component: ExplorerView,
  },
  {
    path: "/explorer/elogin",
    name: "elogin",
    component: ExplorerView,
  },
  {
    path: "/explorer/changelog",
    name: "changelog",
    component: ExplorerView,
  },
  {
    path: "/explorer/faq",
    name: "faq",
    component: ExplorerView,
  },
  {
    path: "/explorer/contact",
    name: "contact",
    component: ExplorerView,
  },
  {
    path: "/explorer/settings",
    name: "settings",
    component: ExplorerView,
  },
  {
    path: "/about",
    name: "aboutall",
    component: AboutView,
  },
  {
    path: "/websites",
    name: "websites",
    component: WebsitesView,
  },
  // {
  //   path: "/explorer",
  //   name: "explorer",
  //   component: ExplorerView,
  // },
  {
    path: "/personalsample",
    name: "personalsample",
    component: PersonalSampleView,
  },
  {
    path: "/checkoutexample",
    name: "checkoutexample",
    component: CheckoutExampleView,
  },
  {
    path: "/contact",
    name: "contactall",
    component: ContactView,
  },
  {
    path: "/techconsult",
    name: "techconsult",
    component: TechConsultView,
  },
  {
    path: "/mentorship",
    name: "mentorship",
    component: MentorshipView,
  },
  {
    path: "/art",
    name: "art",
    component: ArtView,
  },
  {
    path: "/r/:reviewId",
    name: "review-home",
    component: ReviewView,
  },
  {
    path: "/r",
    name: "review-remote",
    component: ReviewView,
  },
  {
    path: "/invoice/:reviewId",
    name: "invoice",
    component: InvoiceView,
  },
  {
    path: "/qb/success",
    name: "success",
    component: SuccessView,
  },
  {
    path: "/stripe/success",
    name: "stripeSuccess",
    component: StripeSuccessView,
  },
  {
    path: "/square/success",
    name: "squareSuccess",
    component: SquareConnectSuccessView,
  },
  {
    path: "/terms",
    name: "terms",
    component: TermsView,
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const signOutUser = (to, from, router) => {
  const userStore = useUser();
  userStore.signOutUser();
};

router.beforeEach((to, from, next) => {
  // console.log("router beforeEach")
  // console.log("before each", to, from, next);
  const userStore = useUser();

  if (to.name === "logout") {
    signOutUser(to, from, router);
    userStore.activeTab = "login";
    next("/login");
  } else if (to.path.includes("/explorer")) {
    userStore.activeTab = to.path;
    next();

    // // console.log("router explorer");
    // if (userStore.user) {
    //   // console.log("router user exists");
    //   userStore.activeTab = to.name || "";
    //   next();
    // } else {
    //   // console.log("router user does not exist");
    //   userStore.activeTab = "login";
    //   next("/login");
    // }
  } else {
    // No authentication required for the route, allow access
    next();
  }

  // TODO: get meta field working
  // console.log("to.meta.requiresAuth: ", to.meta.requiresAuth);
  // const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);
  // if (requiresAuth) {
  // if (dumpStore.user) {
  //   // console.log("user is logged in");
  // } else {
  //   // console.log("user is not logged in");
  //   next("/login");
  // }
  // TODO: get this working, maybe it should go in a store?
  // Check the user's authentication state
  // const auth = getAuth();
  // console.log("auth: ", auth);
  // onAuthStateChanged(auth, (user) => {
  //   console.log("onAuthStateChanged");
  //   console.log("user: ", user);
  //   if (user) {
  //     // User is signed in, allow access
  //     console.log("user is signed in");
  //     dumpStore.user = user;
  //     next();
  //   } else {
  //     // User is not signed in, redirect to the login page
  //     console.log("user is not signed in");
  //     dumpStore.user = null;
  //     router.push("/login");
  //   }
  // });
  // }
});

export default router;
